// Automatically generated
export const USE_PROGRESS_STATE_KEYS = ["value", "min", "max"] as const;
export const PROGRESS_STATE_KEYS = [
  ...USE_PROGRESS_STATE_KEYS,
  "isIndeterminate",
  "percent",
] as const;
export const PROGRESS_KEYS = PROGRESS_STATE_KEYS;
